import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';

const userInfoQuery = gql`
  {
    userInfo {
      id
      showMatureContent
    }
  }
`;

const withToggleMatureContent = Component =>
  graphql(
    gql`
      mutation withToggleMatureContent($show: Boolean!) {
        toggleMatureContent(show: $show) {
          showMatureContent
        }
      }
    `,
    {
      props: ({ mutate }) => {
        return {
          onToggleMatureContent: show =>
            mutate({
              variables: { show },
              optimisticResponse: {
                __typename: 'Mutation',
                toggleMatureContent: {
                  __typename: 'rbm_UserInfo',
                  showMatureContent: show
                }
              },
              update: (proxy, { data: { toggleMatureContent } }) => {
                const { showMatureContent } = toggleMatureContent || {};
                const data = proxy.readQuery({ query: userInfoQuery });

                data.userInfo.showMatureContent = showMatureContent;

                proxy.writeQuery({ query: userInfoQuery, data });
              }
            })
        };
      }
    }
  )(Component);

withToggleMatureContent.displayName = 'withToggleMatureContent';

export default withToggleMatureContent;
